import { Box, Typography } from "@mui/material";

const AuditHeader = () => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
      Audit Logs
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Browse audit trail records across logical databases, with filtering,
      sorting, and date-range search.
    </Typography>
  </Box>
);

export default AuditHeader;
